const DESKTOP = 'desktop'
const TABLET = 'tablet'
const PHONE = 'phone'

export default {
    data() {
        return {
            screenType: PHONE,
            screenWidth: 'none',
            screenHeight: null
        }
    },
    mounted() {
        this._setScreenType()
        window.addEventListener('resize', this._setScreenType)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this._setScreenType)
    },
    methods: {
        _setScreenType() {
            const width = window.innerWidth
            this.screenHeight = window.innerHeight
            if (width >= 1536) {
                this.screenWidth = '2xl'
                this.screenType = DESKTOP
            } else if (width >= 1280) {
                this.screenWidth = 'xl'
                this.screenType = DESKTOP
            } else if (width >= 1024) {
                this.screenWidth = 'lg'
                this.screenType = TABLET
            } else if (width >= 768) {
                this.screenWidth = 'md'
                this.screenType = TABLET
            } else if (width >= 640) {
                this.screenWidth = 'sm'
                this.screenType = PHONE
            } else {
                this.screenWidth = 'none'
                this.screenType = PHONE
            }
        },
        isDesktop() {
            return this.screenType === DESKTOP
        },
        isTablet() {
            return this.screenType === TABLET
        },
        isPhone() {
            return this.screenType === PHONE
        }
    }
}
